import http from '../../http-common'

class DisciplineDataService {

  getDisciplineList() {
    return http.get('/discipline/list')
    .catch((error) => console.log(error.message));
  }

  getDisciplineListByFederation(federationId) {
    return http.get('/discipline/list/' + federationId)
    .catch((error) => console.log(error.message));
  }

}

export default new DisciplineDataService();
